// The public URL an external system posts to: on the public domain the backend sends, else on this app's API host
export const buildWebhookUrl = (webhookSlug: string, resource: string, baseUrl: string | null): string =>
  `${(baseUrl || import.meta.env.VITE_API_URL).replace(/\/+$/, '')}/webhooks/${webhookSlug}/${resource}`;

// What a bcrypt hash looks like, e.g. the value of a SCI_<COMPANY>_TOKEN env var
export const isBcryptHash = (value: string): boolean => /^\$2[aby]\$\d{2}\$[./A-Za-z0-9]{53}$/.test(value);
